/**
 * Created by lihk on 2018/7/24.
 */
cb.define([], function () {
  var PC_pc_shoppresentationclasslist_VM_extend = {

    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function (viewmodel) {
      var shopId = cb.rest.AppContext.user.shop;
      if (null == shopId) {
        viewmodel.get('btnSave').setVisible(false);
      }
      viewmodel.on('shopclasssave', (data) => {
        var treeModel = viewmodel.getTreeModel();
        var keys = treeModel.getNodesByKeys();
        var showClassids = [];
        for (var i = 0; i < keys.length; i++) {
          if (keys[i].ishow == 1) {
            showClassids.push(keys[i].id);
          } else if (keys[i].children && keys[i].children.length) { // 判断子集里面是不是有选中的选项
            let _show = false;
            keys[i].children.forEach(v => {
              _show = (v.ishow == 1) || _show;
            })
            if (_show) {
              showClassids.push(keys[i].id);
            }
          }
        }
        var proxy = cb.rest.DynamicProxy.create({
          ensure: {
            url: '/shopproduct/class/save',
            method: 'POST'
          }
        });
        var params = {
          billnum: "pc_shoppresentationclasslist",
          ids: JSON.stringify(showClassids)
        }
        proxy.ensure(params, function (err, result) {
          if (err) {
            cb.utils.alert(err.message, 'error');
            return;
          }
          cb.utils.alert('保存成功');
          viewmodel.execute('refresh');
        });
      })
    }
  }

  try {
    module.exports = PC_pc_shoppresentationclasslist_VM_extend;
  } catch (error) {

  }
  return PC_pc_shoppresentationclasslist_VM_extend;
});


// WEBPACK FOOTER //
// ./src/client/business/PC/PC_pc_shoppresentationclasslist_VM.Extend.js